export default {
    debug: true,
    state: {
        playHistory: {
            data: [],
            required: true
        },
        historyIdx: {
            data: -1,
            required: true
        }
    },
    putHistory: function (audioItem) {
        if (this.state.playHistory.data.length === 0) {
            this.state.playHistory.data.push(audioItem)
            this.state.historyIdx.data = this.state.playHistory.data.length - 1
        } else {
            const prevHistory = this.state.playHistory.data[
                this.state.playHistory.data.length - 1
            ]
            const isSameSoundPlay =
                audioItem.buttonId === prevHistory.buttonId
            if (!isSameSoundPlay) {
                this.state.playHistory.data.push(audioItem)
                this.state.historyIdx.data = this.state.playHistory.data.length - 1
            }
        }
    },
    setHistoryIdxToNext: function () {
        if (isNaN(this.state.historyIdx.data)) {
            return
        }
        this.state.historyIdx.data = Math.min(
            this.state.historyIdx.data + 1,
            this.state.playHistory.data.length - 1
        )
    },
    setHistoryIdxToPrev: function () {
        if (isNaN(this.state.historyIdx.data)) {
            return
        }
        this.state.historyIdx.data = Math.max(this.state.historyIdx.data - 1, 0)
    },
    getHistorySelectedItem: function () {
        const historyIdx = this.state.historyIdx.data
        const playHistory = this.state.playHistory.data

        if (playHistory == null) {
            return undefined
        }
        if (historyIdx === -1) {
            return undefined
        }
        if (historyIdx < 0 || historyIdx >= playHistory.length) {
            return undefined
        }

        return playHistory[historyIdx]
    },

}
